import { createRouter, createWebHistory } from "vue-router";
import App from "./App.vue";
import store from "./store";

const routes = [
  {
    path: "/dashboard",
    name: "app",
    component: App,
    meta: { requiresAuth: true }, // Menandakan bahwa rute ini memerlukan autentikasi
    children: [
      {
        path: "",
        name: "dashboard",
        component: () => import("./pages/Dashboard.vue"),
      },
      {
        path: "/user-app",
        name: "user-app",
        component: () => import("./pages/master/UserApp.vue"),
      },
      {
        path: "/user-web",
        name: "user-web",
        component: () => import("./pages/master/UserWeb.vue"),
      },
      {
        path: "/report-attendance",
        name: "report-attendance",
        component: () => import("./pages/report/Attendance.vue"),
      },
      {
        path: "/report-itinerary",
        name: "report-itinerary",
        component: () => import("./pages/report/Itinerary.vue"),
      },
      {
        path: "/report-permit",
        name: "report-permit",
        component: () => import("./pages/report/Permit.vue"),
      },
      {
        path: "/report-customer",
        name: "report-customer",
        component: () => import("./pages/report/Customer.vue"),
      },
      {
        path: "/report-bacardi-visit",
        name: "report-bacardi-visit",
        component: () => import("./pages/report/BacardiVisit.vue"),
      },
      {
        path: "/report-bacardi-sales",
        name: "report-bacardi-sales",
        component: () => import("./pages/report/BacardiSales.vue"),
      },
      {
        path: "/report-branding",
        name: "report-branding",
        component: () => import("./pages/report/Branding.vue"),
      },
      {
        path: "/report-sampling-and-selling-summary",
        name: "report-sampling-and-selling-summary",
        component: () => import("./pages/report/SamplingAndSellingSummary.vue"),
      },
      {
        path: "/report-sampling-and-selling-detail",
        name: "report-sampling-and-selling-detail",
        component: () => import("./pages/report/SamplingAndSellingDetail.vue"),
      },
      {
        path: "/example-page",
        name: "example-page",
        component: () => import("./pages/ExamplePage.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./pages/Login.vue"),
  },
  {
    path: "/error",
    name: "error",
    component: () => import("./pages/Error.vue"),
  },
  {
    path: "/access",
    name: "access",
    component: () => import("./pages/Access.vue"),
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("./pages/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("authToken");
  const pageName = to.name;

  if (to.name === "login" && isAuthenticated) {
    next({ name: "dashboard" });
  } else {
    // Mengecek apakah rute saat ini memiliki children
    if (to.matched.some((route) => route.meta.requiresAuth)) {
      // Jika pengguna telah login, lanjutkan ke rute yang diminta
      if (isAuthenticated) {
        store.dispatch("auth/checkPermission", pageName);
        setTimeout(() => {
          if (localStorage.getItem("isPermission") == "false") {
            next({ name: "access" });
          } else {
            next();
          }
        }, 250);
      } else {
        // Jika pengguna belum login, redirect ke halaman login
        next({ name: "login" });
      }
    } else {
      // Jika rute tidak memiliki children, lanjutkan ke rute yang diminta
      next();
    }
  }
});
export default router;
